import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import noImage from "../../images/no_image.jpg";
import "../../css/PropertyValuation.css";
import check from "../../images/check1.jpg";
import advanceValidateForm, {
  propertyValuationDetailValidation,
} from "../validations/CustomAdvanceValidations";
import validateForm, {
  propertyValuationValidation,
} from "../validations/CustomValidations";

import "../../css/AdditionalDetails.css";
import addPhoto1 from "../../images/addphoto1.png";
import additional from "../../images/additional.png";
import { AppContext } from "../../context/AppContext";
import CustomDropdown from "../common/CustomDropdown";
import TipModal from "../modals/TipModal";
import yes from "../../images/yes.png";
import no from "../../images/no.png";
import infoicn from "../../images/info.png";
import PropertyValuationDetailForm from "../forms/PropertyValuationDetailForm";
import { sendWhatsappMessageApi } from "../../api/commonApi";

export default function PropertyValuation() {
  const { user } = useContext(AppContext);

  useEffect(() => {
    handleInputChange("propertyDetails", "userId", user?.data?.id);
  }, [user]);
  const [uniqueId, setUniqueId] = useState(
    Math.floor(100000000000 + Math.random() * 900000000000).toString()
  );
  const [propertyId, setPropertyId] = useState("");
  const cityOptions = [{ value: "1", label: "Jaipur" }];
  const typeOptions = [
    { value: "residential", label: "Residential" },
    { value: "commercial", label: "Commercial" },
  ];
  const serviceOptions = {
    residential: [
      { value: "apartment", label: "Apartment" },
      { value: "villa", label: "Villa" },
      { value: "independent_house", label: "Independent House" },
      { value: "independent_floor", label: "Independent Floor" },
      { value: "plot", label: "Plot" },
      { value: "agricultural_land", label: "Agricultural Land" },
    ],
    commercial: [
      { value: "office", label: "Office" },
      { value: "showroom", label: "Showroom" },
      { value: "retailshop", label: "Retailshop" },
      { value: "plot", label: "Plot" },
      { value: "warehouse", label: "Warehouse" },
    ],
  };
  const bhkOptions = [
    { value: "1 bhk", label: "1 BHK" },
    { value: "2 bhk", label: "2 BHK" },
    { value: "3 bhk", label: "3 BHK" },
    { value: "4 bhk", label: "4 BHK" },
    { value: "5 bhk", label: "5 BHK" },
    { value: "+5 bhk", label: "+5 BHK" },
  ];
 

  const yesNoOption = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" },
  ];
  const landMarkOption = [
    { value: "school", label: "School" },
    { value: "metro", label: "Metro" },
    { value: "hospital", label: "Hospital" },
    { value: "shopping_mall", label: "Shopping Mall" },
  ];

  const FacingOptions = [
    { value: "north", label: "North" },
    { value: "east", label: "East" },
    { value: "west", label: "West" },
    { value: "south", label: "South" },
    { value: "north-east", label: "North-East" },
    { value: "north-west", label: "North-West" },
    { value: "south-east", label: "South-East" },
    { value: "south-west", label: "South-West" },
  ];

  const overOptions = [
    { value: "garden", label: "Garden" },
    { value: "main_road", label: "Main Road" },
  ];

  const plotAuthority = [
    { value: "RHB", label: "RHB" },
    { value: "JDA", label: "JDA" }
  ];
  const zeroFourOption = [
    { value: "0", label: "0" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" }
  ];


  const options = ["School", "Metro", "Hospital", "Shopping Mall"];

  const [dataFields, setDataFields] = useState([]);
  const [dataDescriptions, setDataDescriptions] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  // const [selectedOption, setSelectedOption] = useState("");

  const mainSteps = ["details", "images", "advanced", "verify"];
  const steps = ["Property Details", "Advanced  Details", "Property Visit"];
  const [activeStep, setActiveStep] = useState(0);
  const [activeMainStep, setActiveMainStep] = useState(0);

  // const handleOptionClick = (option) => {
  //   setSelectedOption(option);
  // };

  const handlePostPropertyClick = () => {
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
      setActiveMainStep(1);
    }, 5000);
  };

  const token = localStorage.getItem("authToken");

  // State to store form data for all steps
  const [formData, setFormData] = useState({
    propertyDetails: {
      property_category: "",
      userId: "",
      id: "",
      locality: "",
      sub_locality: "",
      property_type: "",
      bhk: "",
      buildup_area: "",
      total_floor: "",
      floor: [],
      property_age: "",
      corner_plot: "",
      plot_authority: "",
      interiors: "",
      facing: "",
      over_looking: "",
      reminder_date: "",
      reminder_time: "",
      land_mark: [],
      plot_area: "",
      parking_open: "",
      parking_covered: "",
      width_facing_road: "",
      length: "",
      width: "",
      zone_type: "",
      ownership: "",
      area_unit: "",
      transaction_type: "",
      number_seat: "",
      number_cabin: "",
      number_meeting: "",
      conference_room: "",
      entrance_width: "",
      ceiling_height: "",
      address: "",
      total_stairs: "",
    },
  });

  const [floorOptions, setFloorOptions] = useState([]);
  useEffect(() => {
    const totalFloors = parseInt(formData.propertyDetails.total_floor) || 0;
    
    const newOptions = Array.from({ length: totalFloors + 1 }, (_, i) => ({
      label: i.toString(),
      value: i.toString(),
    }));
    setFloorOptions(newOptions);
  },[formData.propertyDetails.total_floor]);

  const [errors, setErrors] = useState({});

  const handleInputDelete = (step, priceIndex = null) => {
    if (step === "roomDetail" && priceIndex !== null) {
      setFormData((prev) => {
        const updatedRoomDetails = { ...prev[step] };

        // Remove the entire object at `priceIndex`
        delete updatedRoomDetails[priceIndex];

        return {
          ...prev,
          [step]: updatedRoomDetails,
        };
      });

      setErrors((prev) => {
        const updatedErrors = { ...prev[step] };

        // Remove errors related to this `priceIndex`
        delete updatedErrors[priceIndex];

        return {
          ...prev,
          [step]: updatedErrors,
        };
      });

      console.log(formData);
    }
  };

  const handleInputChange = (step, field, value, priceIndex = null) => {
    if (step === "roomDetail" && priceIndex !== null) {
      setFormData((prev) => ({
        ...prev,
        [step]: {
          ...prev[step],
          [priceIndex]: {
            ...(prev[step]?.[priceIndex] || {}), // Preserve existing data at this index
            [field]: value, // Push new field-value
          },
        },
      }));

      setErrors((prev) => ({
        ...prev,
        [step]: {
          ...(prev[step] || {}),
          [priceIndex]: {
            ...(prev[step]?.[priceIndex] || {}),
            [field]: "", // Clear error for the specific field
          },
        },
      }));

      console.log(formData);
    } else {
      setFormData((prev) => ({
        ...prev,
        [step]: {
          ...prev[step],
          [field]: value,
        },
      }));
      setErrors((prev) => ({
        ...prev,
        [field]: "", // Clear error for the field being modified
      }));

      console.log(formData);
    }
  };

  const handleMultiSelect = (option) => {
    setFormData((prevData) => {
      const selectedLandMarks = prevData.propertyDetails.land_mark || [];

      return {
        ...prevData,
        propertyDetails: {
          ...prevData.propertyDetails,
          land_mark: selectedLandMarks.includes(option)
            ? selectedLandMarks.filter((item) => item !== option) // Remove if already selected
            : [...selectedLandMarks, option], // Add if not selected
        },
      };
    });
  };

  const handleActiveSteps = (index) => {};

  const handleNextStep = (index = null) => {
    if (index < activeStep) {
      setActiveStep(index);
      return;
    } else if (index > activeStep) {
      return;
    }
    const validationErrors = propertyValuationValidation(activeStep, formData);
    setErrors(validationErrors);
    
    if (Object.keys(validationErrors).length === 0) {
    
      setActiveStep((prev) => prev + 1);
    }
  };

  //  const handleSubmitDetail = async (e) => {
  //     if (e) e.preventDefault(); // Prevent default form submission// Prevent default form submission behavior

  //     // Validate input fields
  //     const validationErrors = projectValidation(formData);
  //     //alert(validationErrors);
  //     setErrors(validationErrors);

  //     // If errors exist, return early
  //     if (Object.keys(validationErrors).length > 0) {
  //       return;
  //     }

  //   };

  const handleAdvanceSubmit = async (e) => {
    e.preventDefault();
    const advanceValidationErrors = propertyValuationDetailValidation(formData);
    setErrors(advanceValidationErrors);

    if (Object.keys(advanceValidationErrors).length === 0) {
      createOrUpdateProperty();
      navigate("/myProfile?value=MyPropertyValuation");
    } else {
    }
  };
  const handleSetReminderSubmit = async (e) => {
    e.preventDefault();
    //alert(propertyId);

    // handleInputChange('basicDetails', 'id', propertyId)

    createOrUpdateProperty();
    alert("Reminder Set");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = propertyValuationValidation(activeStep, formData);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length != 0) {
    } else {
      // setPropertyId(2);
      //  handlePostPropertyClick();
      createOrUpdateProperty();
      //handlePostPropertyClick();
    }
  };

  const createOrUpdateProperty = async (e) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/addPropertyValuationDetail`,
        formData,
        {}
      );
      if (response.status === 201) {
        // setPropertyId(response.data.id);
        handleInputChange("propertyDetails", "id", response.data.id);
        handlePostPropertyClick();
        if(user?.data?.mobile)
          {

   
      await sendWhatsappMessageApi({
           slug: 'property_valuation_enquiry',
           mobile: user?.data?.mobile,
           name: user?.data?.name || 'User',
           title: response.data?.title,
           location: response.data?.location,
           token: token,
       
         });
        }
        // setActiveMainStep(1);
      }
    
      if (response.status === 201) {
        setActiveMainStep(1);


        
        // handlePostPropertyClick();
        // setActiveMainStep(1);
      } else {
        setErrors("Failed to add property. Please try again.");
      }
    } catch (error) {
      console.error("Property Add error:", error);
      setErrors("An error occurred. Please try again later.");
    }
  };
  const [images, setImages] = useState([]);

  // Handle file selection
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    uploadImages(files);
  };

  // Handle drag-over event
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // Handle drop event
  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    uploadImages(files);
  };

  // Handle delete image
  const handleCategory = async (imageId, value) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/valuationImageCategory`,
        {
          method: "POST", // Use POST if DELETE is not supported
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ image_id: imageId, category: value }),
        }
      );

      const result = await response.json();
      console.log(result);

      if (result.status) {
        // Remove the deleted image from state
        console.error("Category Save");
      } else {
        alert("Failed to save category!");
      }
    } catch (error) {
      console.error("Error save category:", error);
    }
  };

  // Handle delete image
  const handleDelete = async (index, imageId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/deletePropertyValuationImages`,
        {
          method: "POST", // Use POST if DELETE is not supported
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ image_id: imageId }),
        }
      );

      const result = await response.json();
      console.log(result);

      if (result.status) {
        // Remove the deleted image from state
        setImages((prevImages) => prevImages.filter((_, i) => i !== index));
      } else {
        alert("Failed to delete image!");
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  const uploadImages = async (files) => {
    const formImageData = new FormData();
    files.forEach((file) => formImageData.append("images[]", file));
    formImageData.append("property_id", formData.propertyDetails.id);
    formImageData.append("user_id", formData.propertyDetails.userId);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/uploadPropertyValuationImages`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formImageData,
        }
      );

      const result = await response.json();

      if (result.status) {
        setImages((prevImages) => [...prevImages, ...result.data]);
      } else if (!result.status) {
        alert("something went wrong");
      }
    } catch (error) {
      console.error("Error uploading images:", error);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openVisibleModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeVisibleModal = () => {
    setIsModalOpen(false);
  };

  const [projectInput, setProjectInput] = useState("");
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);

  const [localityInput, setLocalityInput] = useState("");
  const [localities, setLocalities] = useState([]);
  const [showLocalityDropdown, setShowLocalityDropdown] = useState(false);
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [loadingLocalities, setLoadingLocalities] = useState(false);

  const handleLocalityInputChange = (e) => {
    setLocalityInput(e.target.value);
    setShowLocalityDropdown(true);
    handleInputChange('propertyDetails', 'sub_locality', '')
    handleInputChange('propertyDetails', 'locality', '')
  };
  const handleLocalitySelect = (locality) => {
    setLocalityInput(locality.title);
    handleInputChange("propertyDetails", "locality", locality.locality_id);
    handleInputChange("propertyDetails", "sub_locality", locality.id);
    setShowLocalityDropdown(false); // Hide dropdown after selection
  };

  // Fetch projects based on user input
  useEffect(() => {
    if (projectInput.trim() === "") {
      setProjects([]);
      return;
    }

    setLoadingProjects(true);
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/search/projects?query=${projectInput}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Get token from localStorage
          },
        }
      )
      .then((response) => {
        setProjects(response.data.data);
      })
      .catch((error) => {
        if (error.status === 404) {
          setProjects([]);
        }
      })
      .finally(() => setLoadingProjects(false));
  }, [projectInput]);

  // Fetch localities when a project is selected
  useEffect(() => {
    setLoadingLocalities(true);
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/search/localities?query=${localityInput}&city_id=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Get token from localStorage
          },
        }
      )
      .then((response) => {
        setLocalities(response.data.data || []);
      })
      .catch((error) => console.error("Error fetching localities:", error))
      .finally(() => setLoadingLocalities(false));
  }, [localityInput]);
  const [isTipModalOpen, setIsTipModalOpen] = useState(false);

  const openTipModal = () => {
    setIsTipModalOpen(true);
    const dataLabels = getAllDataLabels("myForm");
    const dataDescriptions = getAllDataDescriptions("myForm");
    setDataFields(dataLabels);
    setDataDescriptions(dataDescriptions);
  };
  // Function to close the Tip Modal
  const closeTipModal = () => {
    setIsTipModalOpen(false);
  };

  function getAllDataLabels(formId) {
    // Select the form by its ID
    const form = document.getElementById(formId);

    // If form is found, proceed
    if (form) {
      // Get all elements within the form with a 'data-label' attribute
      const elements = form.querySelectorAll("[data-field]");

      // Map the elements to extract their 'data-label' values
      const labels = Array.from(elements).map((element) =>
        element.getAttribute("data-field")
      );

      // Return the array of data-label values
      return labels;
    } else {
      console.error("Form not found");
      return [];
    }
  }

  function getAllDataDescriptions(formId) {
    // Select the form by its ID
    const form = document.getElementById(formId);

    // If form is found, proceed
    if (form) {
      // Get all elements within the form with a 'data-label' attribute
      const description = form.querySelectorAll("[data-description]");

      // Map the elements to extract their 'data-label' values
      const descriptions = Array.from(description).map((element) =>
        element.getAttribute("data-description")
      );

      // Return the array of data-label values
      return descriptions;
    } else {
      console.error("Form not found");
      return [];
    }
  }
  

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <div className="forms" id="myForm">
            <TipModal
              dataFields={dataFields}
              dataDescriptions={dataDescriptions}
              isOpen={isTipModalOpen}
              closeModal={closeTipModal}
            />
            <div className="formHeader" onClick={() => openTipModal()}>
              <span>Add Property Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBodyMain">
              <div
                className={`formRow mt-4 ${ errors.locality ? "mb-5" : "mb-3"
                }`}
              >
                <div className="input-container w-100">
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="localityInput"
                      placeholder=" "
                      value={localityInput}
                      onChange={handleLocalityInputChange}
                      className="textField"
                    />
                    <label htmlFor="localityInput" className="floating-label">
                      Locality
                      <span className="required_field">*</span>
                    </label>
                  </div>

                  {loadingLocalities && (
                    <div className="loading">Loading localities...</div>
                  )}

                  {showLocalityDropdown && localities.length > 0 && (
                    <ul className="autocomplete-dropdown">
                      {localities.map((locality) => (
                        <li
                          key={locality.id}
                          className="autocomplete-item"
                          onClick={() => handleLocalitySelect(locality)}
                        >
                          {locality.title}
                        </li>
                      ))}
                    </ul>
                  )}

                  {errors.locality && (
                    <small className="text-danger">{errors.locality}</small>
                  )}
                </div>
              </div>
              <div
                className={`formRow mt-4 ${
                  errors.property_category || errors.property_type
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className=" w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"property_category"}
                    options={typeOptions}
                    placeholder="Property Category"
                    required={"1"}
                    onSelect={(value) =>
                      console.log("property_category:", value)
                    }
                  />
                  {errors.property_category && (
                    <small className="text-danger">
                      {errors.property_category}
                    </small>
                  )}
                </div>
                <div className=" w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"property_type"}
                    required={"1"}
                    options={
                      serviceOptions[
                        formData.propertyDetails?.property_category
                      ] || []
                    }
                    page="valuation"
                    placeholder="Property Type"
                    onSelect={(value) => console.log("property_type:", value)}
                  />
                  {errors.property_type && (
                    <small className="text-danger">
                      {errors.property_type}
                    </small>
                  )}
                </div>
              </div>
              <div className={`formRow mt-4 ${errors.total_floor || errors.floor ? "mb-5" : "mb-3"}`}>
                {["apartment","villa","independent_floor","independent_house","office","showroom","retailshop","warehouse"].includes(formData.propertyDetails.property_type) && (
                  <>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="total_floor"
                        placeholder=" "
                        value={formData.propertyDetails.total_floor || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "total_floor",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="total_floor" className="floating-label">
                        Total Floor <span className='required_field'>*</span>
                      </label>
                      {errors.total_floor && (
                        <small className="text-danger">
                          {errors.total_floor}
                        </small>
                      )}
                    </div>
                  </>
                )}
                {["apartment","villa","office","showroom","retailshop","warehouse"].includes(formData.propertyDetails.property_type) && (
                  <>
                    <div className=" w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"floor"}
                        multiple={true}
                        options={floorOptions}
                        placeholder="Floor"
                        onSelect={(value) => console.log("floor:", value)}
                      />
                      {errors.floor && (
                        <small className="text-danger">{errors.floor}</small>
                      )}
                    </div>
                  </>
                )}
              </div>
               
              {["apartment","villa","independent_floor","independent_house",].includes(formData.propertyDetails.property_type) && (
                <>
                  <div className={`formRow mt-4 ${errors.bhk ? "mb-5" : "mb-3"}`}>
                    <div className=" w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"bhk"}
                        options={bhkOptions}
                        placeholder="BHK Type"
                        required={"1"}
                        onSelect={(value) => console.log("bhk:", value)}
                      />
                      {errors.bhk && (
                        <small className="text-danger">{errors.bhk}</small>
                      )}
                    </div>
                  </div>
                </>
              )}
              <div className={`formRow mt-4 ${errors.corner_plot || errors.plot_authority ? "mb-5" : "mb-3"}`}>
                {["plot"].includes(formData.propertyDetails.property_type) && (
                  <>
                     <div className=' w-50'>
                        <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'corner_plot'} required={'1'} options={yesNoOption} placeholder="Corner Plot" onSelect={(value) => console.log("corner_plot:", value)} />
                        {errors.corner_plot && <small className="text-danger">{errors.corner_plot}</small>}
                      </div>
                  </>
                )}
               {["plot","agricultural_land"].includes(formData.propertyDetails.property_type) && (
                  <>
                    <div className='w-50'>
                     <CustomDropdown formData={formData} handleInputChange={handleInputChange} index={'propertyDetails'} field={'plot_authority'} options={plotAuthority} placeholder="Approving Authorities" required={'1'} onSelect={(value) => console.log("approving authorities:", value)} />
                      {errors.plot_authority && <small className="text-danger">{errors.plot_authority}</small>}
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="formFooter">
              <div className="rectangle_323" onClick={handleNextStep}>
                <button className="ribbonText">Next</button>
              </div>
            </div>
          </div>
        );
      default:
        return (
          <PropertyValuationDetailForm
            activeStep={activeStep}
            errors={errors}
            formData={formData}
            handleInputChange={handleInputChange}
            handleInputDelete={handleInputDelete}
            handleNextStep={handleNextStep}
            handleSubmit={handleSubmit}
            handlePostPropertyClick={handlePostPropertyClick}
          />
        );
      // }
    }
  };

  switch (mainSteps[activeMainStep]) {
    case "details":
      return (
        <div className="exterior propval pt-2 pb-5">
          <div className="heading pt-5">Property Valuation</div>
          <div className="outerBox">
            <div className="sideBox1">
              <h5 className="lefthd desk">How much is my property worth?</h5>
            </div>
            <div className="sideBox2">
            <h5 className="lefthd mob">How much is my property worth?</h5>
              <div className="stepbar">
                {steps.map((step, index) => (
                  <React.Fragment key={index}>
                    <div
                      className="stepbox"
                      onClick={() => handleNextStep(index)}
                    >
                      <p
                        className={`steptxt ${
                          activeStep > index ? "active" : ""
                        }`}
                      >
                        {step}
                      </p>

                      <div
                        className={`stepdot ${
                          activeStep === index
                            ? "active"
                            : activeStep > index
                            ? "visited"
                            : ""
                        }`}
                      >
                        <div
                          className={`stepindot ${
                            activeStep === index
                              ? "active"
                              : activeStep > index
                              ? "visited"
                              : ""
                          }`}
                        >
                          {activeStep > index ? (
                            <svg
                              width="14"
                              height="10"
                              viewBox="0 0 14 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.40039 5.39981L5.13399 8.99981L12.6004 1.7998"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>

                    {index < steps.length - 1 && (
                      <div
                        className={`stepline  ${
                          activeStep > index ? "active" : ""
                        }`}
                      ></div>
                    )}
                  </React.Fragment>
                ))}
              </div>

              {renderStepContent(activeStep)}
            </div>
            {showPopup && (
              <div className="popupbox">
                <div className="popup">
                  <div className="check-div">
                    <img src={check} alt="Popup" className="check" />
                  </div>
                  <div className="" style={{ marginTop: "-15%" }}>
                    <h2 className="congr-text">
                      Congratulations! <br />
                      Our Experts are evaluating your property.
                    </h2>
                    <p className="congr-text-p mt-4">
                      Meanwhile you can add photos/Videos & other additional
                      details of your property for more precise valuation.{" "}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* <div className="outerBox section-plan">
            <div>
              <h3>Purchase one time plan to Evaluate your property</h3>
            </div>



            <div className='planbox'>
              <div className='pbleft'>
                <div className='rowhdht pbrowhd colblank'></div>
                <div className='rowht pbrowhd colhd1'>Allowed to Evaluate Properties</div>
                <div className='rowht pbrowhd colhd2'>Visibility on Home Page and Search Result</div>
                <div className='rowht pbrowhd colhd3'>Highlight your brand with "Verified Project" tag</div>
                <div className='rowht pbrowhd colhd4'>Highlight your brand with "Premium Project" tag</div>
              </div>
              <div className='pb pb1'>
                <div className='rowhdht pbcolhd'>Basic</div>

                <div className='mobcolhdspace'></div>
                <div className='rowht pbdata'>1</div>

                <div className='mobcolhdspace'></div>
                <div className='rowht pbdata'><img src={no} /></div>

                <div className='mobcolhdspace'></div>
                <div className='rowht pbdata'><img src={yes} /></div>

                <div className='mobcolhdspace'></div>
                <div className='rowht pbdata'><img src={no} /></div>

                <div className='rowht pbdata pbprice'>
                  <span className='pric'>₹1099</span> 
                  <span className='gst'>+GST</span>
                  <sup>
                    <span className='infoicn' data-bs-toggle="tooltip" data-bs-placement="top" title="+18% GST = ₹108">
                      <img src={infoicn} />
                    </span>
                  </sup>
                </div>
                <div className='rowht pbdata pbbtn'>
                  <div class="d-grid gap-2">
                    <button class="buy-btn full-wid">BUY</button>
                  </div>
                </div>
              </div>

              <div className='pb2 pbpopular'>
                <div className='rowhdht pbcolhd'>Pro</div>

                <div className='mobcolhdspace'></div>
                <div className='rowht pbdata'>3</div>

                <div className='mobcolhdspace'></div>
                <div className='rowht pbdata'><img src={yes} /></div>

                <div className='mobcolhdspace'></div>
                <div className='rowht pbdata'><img src={yes} /></div>

                <div className='mobcolhdspace'></div>
                <div className='rowht pbdata'><img src={no} /></div>

                <div className='rowht pbdata pbprice'>
                  <span className='pric'>₹2099</span> 
                  <span className='gst'>+GST</span>
                  <sup>
                    <span className='infoicn' data-bs-toggle="tooltip" data-bs-placement="top" title="+18% GST = ₹108">
                      <img src={infoicn} />
                    </span>
                  </sup>
                </div>
                <div className='rowht pbdata pbbtn'>
                <div class="d-grid gap-2">
                    <button class="buy-btn full-wid">BUY</button>
                  </div>
                </div>
              </div>

              <div className='pb pb3'>
                <div className='rowhdht pbcolhd'>Premium</div>

                <div className='mobcolhdspace'></div>
                <div className='rowht pbdata'>5</div>

                <div className='mobcolhdspace'></div>
                <div className='rowht pbdata'><img src={yes} /></div>

                <div className='mobcolhdspace'></div>
                <div className='rowht pbdata'><img src={yes} /></div>

                <div className='mobcolhdspace'></div>
                <div className='rowht pbdata'><img src={yes} /></div>

                <div className='rowht pbdata pbprice'>
                  <span className='pric'>₹5099</span> 
                  <span className='gst'>+GST</span>
                  <sup>
                    <span className='infoicn' data-bs-toggle="tooltip" data-bs-placement="top" title="+18% GST = ₹108">
                      <img src={infoicn} />
                    </span>
                  </sup>
                </div>
                <div className='rowht pbdata pbbtn'>
                  <div class="d-grid gap-2">
                    <button class="buy-btn full-wid">BUY</button>
                  </div>
                </div>
              </div>
            </div>


          </div> */}
        </div>
      );

    case "images":
      return (
        <div className="exterior1">
          <div className="property-container">
            <div className="property-left-box">
              <div className="property-header">
                <p className="property-title">
                  Congratulations! <br /> Our Experts are evaluating your
                  property.
                </p>
                <p className="property-subtitle" style={{ marginTop: "50px" }}>
                  Meanwhile you can add photos/Videos & other <br /> additional
                  details of your property to for more <br /> precise valuation.
                </p>
              </div>
              <div
                className="property-options-box"
                style={{ marginTop: "90px", marginLeft: "99px" }}
              >
                <div className="options-cat">
                  <img src={addPhoto1} alt="Return to Dashboard" />
                  <button
                    className="options-cat-name"
                    onClick={() => setActiveMainStep(0)}
                  >
                    Add Photos/Videos
                  </button>
                </div>
                <div className="options-cat">
                  <img src={additional} alt="Add Photos/Videos" />
                  <button
                    className="options-cat-name"
                    onClick={() => setActiveMainStep(2)}
                  >
                    Additional Features
                  </button>
                </div>
              </div>
            </div>
            {/* <pre>{JSON.stringify(formData, null, 2)}</pre> */}
            <div className="property-right-box">
              <div className="rightBox-title">
                <div>Add Photos/Videos</div>
                <div>
                  <button
                    className="rbButton"
                    onClick={() => setActiveMainStep(2)}
                  >
                    {images.length >= 1 ? "Next" : "Skip"}{" "}
                    <span className={images.length >= 1 ? "arrow1" : ""}>
                      &gt;&gt;
                    </span>
                  </button>
                </div>
              </div>
              <div>
                <div className="rb1">
                  {images.map((image, index) => (
                    <div key={index} style={{ width: "90px" }}>
                      <img
                        src={image.image_url}
                        className="rbox"
                        alt={`Uploaded ${index}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = noImage;
                        }}
                      />
                      <button
                        className="delete-button btn"
                        onClick={() => handleDelete(index, image.id)}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2785_1188)">
                            <path
                              d="M7.64199 12.3587L12.3587 7.64199M12.3587 12.3587L7.64199 7.64199M10.0003 18.3337C14.5837 18.3337 18.3337 14.5837 18.3337 10.0003C18.3337 5.41699 14.5837 1.66699 10.0003 1.66699C5.41699 1.66699 1.66699 5.41699 1.66699 10.0003C1.66699 14.5837 5.41699 18.3337 10.0003 18.3337Z"
                              stroke="#B7B7B7"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2785_1188">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                      {/* <div className="image-dropdown">
                        {image.image_url.toLowerCase().endsWith(".pdf") ? (
                          // Dropdown for PDFs
                          <select
                            className="image-dropdown1"
                            onChange={(e) =>
                              handleCategory(image.id, e.target.value)
                            }
                          >
                            <option value="">Select</option>
                            <option value="brochure">Brochure</option>
                          </select>
                        ) : (
                          // Dropdown for images
                          <select
                            className="image-dropdown1"
                            onChange={(e) =>
                              handleCategory(image.id, e.target.value)
                            }
                          >
                            <option value="">Select</option>
                            <option value="cover">Cover</option>
                            <option value="living">Living Room</option>
                            <option value="kitchen">Kitchen</option>
                            <option value="bathroom">Bathroom</option>
                            <option value="dining room">Dining Room</option>
                            <option value="laundary room">Laundry Room</option>
                            <option value="bedroom">Bedroom</option>
                            <option value="balcony">Balcony</option>
                            <option value="front view">Front View</option>
                            <option value="garden">Garden</option>
                            <option value="terrace">Terrace</option>
                            <option value="rooftop">Rooftop</option>
                            <option value="parking area">Parking Area</option>
                            <option value="swimming pool">Swimming Pool</option>
                            <option value="gym">Gym </option>
                            <option value="play area">Play Area </option>
                            <option value="lift / staircase">Lift / Staircase </option>
                            <option value="office space">Office Space</option>
                            <option value="meeting / conference room">Meeting / Conference Room</option>
                            <option value="retail / shop area">Retail / Shop Area</option>
                            <option value="warehouse">Warehouse</option>
                            <option value="reception">Reception</option>
                            <option value="prayer room">Prayer Room</option>
                          </select>
                        )}
                      </div> */}
                    </div>
                  ))}
                </div>
                <div
                  className="insbox"
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  <p>Drag & Drop here</p>
                  <p>or</p>

                  <label for="file-upload" className="image-label">
                    Browse
                  </label>
                  <input
                    type="file"
                    id="file-upload"
                    className="instext"
                    multiple
                    onChange={(e) => handleFileChange(e)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );

    case "advanced":
      return (
        <div className="exterior1">
          <div className="property-container">
            <div className="property-left-box">
              {/* <pre>{JSON.stringify(formData, null, 2)}</pre> */}
              <div className="property-header">
                <p className="property-title">
                  Congratulations! <br /> Our Experts are evaluating your
                  property.
                </p>
                <p className="property-subtitle" style={{ marginTop: "50px" }}>
                  Meanwhile you can add photos/Videos & other <br /> additional
                  details of your property to for more <br /> precise valuation.
                </p>
              </div>
              <div
                className="property-options-box"
                style={{ marginTop: "90px", marginLeft: "99px" }}
              >
                <div className="options-cat">
                  <img src={addPhoto1} alt="Return to Dashboard" />
                  <button
                    className="options-cat-name"
                    onClick={() => setActiveMainStep(1)}
                  >
                    Add Photos/Videos
                  </button>
                </div>
                <div className="options-cat">
                  <img src={additional} alt="Add Photos/Videos" />
                  <button
                    className="options-cat-name"
                    onClick={() => setActiveMainStep(2)}
                  >
                    Additional Features
                  </button>
                </div>
              </div>
            </div>
            <div className="property-right-box">
              <div className="rightBox-title">
                <div>Add Additional Features</div>
                <div>
                  {/* <button className="rbButton"> Skip&gt;&gt;</button>{" "} */}
                </div>
              </div>
              <div className="formBody1">
                {["office","showroom","retailshop","warehouse"].includes(formData.propertyDetails.property_type) && (
                  <>
                    <div className={`formRow mt-4 ${errors.parking_open || errors.parking_covered ? "mb-5" : "mb-3"}`}>
                      <div className="w-50">
                        <CustomDropdown
                          formData={formData}
                          handleInputChange={handleInputChange}
                          index={"propertyDetails"}
                          field={"parking_open"}
                          options={zeroFourOption}
                          placeholder="Parking Open"
                          required={"1"}
                          onSelect={(value) =>
                            console.log("parking_open:", value)
                          }
                        />
                        {errors.parking_open && (
                          <small className="text-danger">
                            {errors.parking_open}
                          </small>
                        )}
                      </div>
                      <div className="w-50">
                        <CustomDropdown
                          formData={formData}
                          handleInputChange={handleInputChange}
                          index={"propertyDetails"}
                          field={"parking_covered"}
                          options={zeroFourOption}
                          placeholder="Parking Covered"
                          required={"1"}
                          onSelect={(value) =>
                            console.log("parking_covered:", value)
                          }
                        />
                        {errors.parking_covered && (
                          <small className="text-danger">
                            {errors.parking_covered}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className={`formRow mt-4 ${errors.total_stairs ? "mb-5": "mb-3"}`}>
                       <div className="input-container d-grid w-50">
                          <input
                            type="text"
                            id="total_stairs"
                            placeholder=" "
                            className="textField"
                            value={formData.propertyDetails.total_stairs || ''}
                            onChange={(e) => handleInputChange('propertyDetails', 'total_stairs', e.target.value)}
                            onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                          />
                          <label htmlFor="reraId" className="floating-label">
                            Number of Staircase
                          </label>
                          {errors.total_stairs && <small className="text-danger">{errors.total_stairs}</small>}
                        </div>
                    </div>
                  </>
                )}
                {["apartment","villa","independent_floor","independent_house","plot","agricultural_land"].includes(formData.propertyDetails.property_type) && (
                  <>
                    <div className={`formRow mt-4 ${errors.facing || errors.over_looking ? "mb-5" : "mb-3"}`}>
                      <div className=" w-50">
                        <CustomDropdown
                          formData={formData}
                          handleInputChange={handleInputChange}
                          index={"propertyDetails"}
                          field={"facing"}
                          required={"1"}
                          options={FacingOptions}
                          placeholder="facing"
                          onSelect={(value) => console.log("facing:", value)}
                        />
                        {errors.facing && (
                          <small className="text-danger">{errors.facing}</small>
                        )}
                      </div>
                      <div className=" w-50">
                        <CustomDropdown
                          formData={formData}
                          handleInputChange={handleInputChange}
                          index={"propertyDetails"}
                          multiple={true}
                          field={"over_looking"}
                          options={overOptions}
                          placeholder="Overlooking"
                          required={"1"}
                          onSelect={(value) =>
                            console.log("over_looking:", value)
                          }
                        />
                        {errors.over_looking && (
                          <small className="text-danger">
                            {errors.over_looking}
                          </small>
                        )}
                      </div>
                    </div>
                  </>
                )}
                <div className={`formRow mt-4 ${errors.address ? "mb-5" : "mb-3"}`}>
                    <div className="input-container d-grid w-100">
                      <input
                        type="text"
                        id="address"
                        placeholder=" "
                        className="textField"
                        value={formData.propertyDetails.address || ''}
                        onChange={(e) => handleInputChange('propertyDetails', 'address', e.target.value)}
                      />
                      <label htmlFor="address" className="floating-label">
                        Address
                      </label>
                      {errors.address && <small className="text-danger">{errors.address}</small>}
                    </div>

                </div>
                <label
                  className="formLabel mt-3"
                  data-index="propertyDetails"
                  data-field="self"
                  data-description="self description"
                >
                  Nearby Landmarks:
                </label>
                <div className="optionList mt-3 mb-3">
                  {options.map((option, index) => (
                    <div
                      key={index}
                      className={`optionBox ${
                        formData.propertyDetails.land_mark.includes(option)
                          ? "active"
                          : ""
                      }`}
                      onClick={() => handleMultiSelect(option)}
                    >
                      <span
                        className={`label_icon ${
                          formData.propertyDetails.land_mark.includes(option)
                            ? "label_icon_active"
                            : ""
                        }`}
                      >
                        {formData.propertyDetails.land_mark.includes(option)
                          ? "✓"
                          : "X"}
                      </span>
                      <span>{option}</span>
                    </div>
                  ))}
                </div>
                {errors.land_mark && (<small className="text-danger">{errors.land_mark}</small>)}
                <div className="ribbon mt-2">
                  <button
                    className="ribbonText"
                    onClick={(e) => handleAdvanceSubmit(e)}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
  }
}
